export const CategoryConstants = {
    CATEGORY_ADDED_REQUEST:'CATEGORY_ADDED_REQUEST',
    CATEGORY_ADDED_SUCCESS:'CATEGORY_ADDED_SUCCESS',
    CATEGORY_ADDED_FAILURE:'CATEGORY_ADDED_FAILURE',  
        

    CATEGORY_GET_REQUEST:'CATEGORY_GET_REQUEST',
    CATEGORY_GET_SUCCESS:'CATEGORY_GET_SUCCESS',
    CATEGORY_GET_FAILURE:'CATEGORY_GET_FAILURE',

    SUB_CATEGORY_GET_REQUEST:'SUB_CATEGORY_GET_REQUEST',
    SUB_CATEGORY_GET_SUCCESS:'SUB_CATEGORY_GET_SUCCESS',
    SUB_CATEGORY_GET_FAILURE:'SUB_CATEGORY_GET_FAILURE',
    
    CATEGORY_BY_ID_REQUEST : 'CATEGORY_BY_ID_REQUEST',
    CATEGORY_BY_ID_SUCCESS : 'CATEGORY_BY_ID_SUCCESS',
    CATEGORY_BY_ID_FAILURE : 'CATEGORY_BY_ID_FAILURE',

    CATEGORY_EDIT_REQUEST:'CATEGORY_EDIT_REQUEST',
    CATEGORY_EDIT_SUCCESS:'CATEGORY_EDIT_SUCCESS',
    CATEGORY_EDIT_FAILURE:'CATEGORY_EDIT_FAILURE',


    CATEGORY_GET_ACTIVE_REQUEST:'CATEGORY_GET_ACTIVE_REQUEST',
    CATEGORY_GET_ACTIVE_SUCCESS:'CATEGORY_GET_ACTIVE_SUCCESS',
    CATEGORY_GET_ACTIVE_FAILURE:'CATEGORY_GET_ACTIVE_FAILURE',

    CATEGORY_DELETE_REQUEST:'CATEGORY_DELETE_REQUEST',
    CATEGORY_DELETE_SUCCESS:'CATEGORY_DELETE_SUCCESS',
    CATEGORY_DELETE_FAILURE:'CATEGORY_DELETE_FAILURE',
};
